import React, { useEffect, useState } from 'react';
import { DeleteOutlined, DownloadOutlined, PlusOutlined, ReloadOutlined, StarFilled } from '@ant-design/icons';
import { APP_DETAILS_ACTION_LIST, AppConstants, DEFAULT_FORMAT } from '@constants';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseTable } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { showErrorMessage, showSucsessMessage } from '@services/notifyService';
import { convertUtcToLocalTime } from '@utils';
import { Button, Modal } from 'antd';

const AppVersionTable = ({ service, onAdd }) => {
    const translate = useTranslate();
    const [tableData, setTableData] = useState([]);

    const { execute: executeGetList, loading: loadingList } = useFetch(apiConfig.file.appDetails);
    const { execute: executeDelete, loading: loadingDelete } = useFetch(apiConfig.file.deleteVersion);

    const fetchList = () => {
        executeGetList({
            params: { service, action: APP_DETAILS_ACTION_LIST },
            onCompleted: (res) => {
                if (res.result) {
                    const content = res.data?.metadata || [];
                    setTableData(
                        content.map((item, index) => ({
                            ...item,
                            key: item.id || index,
                            isActiveVersion: index === 0,
                        })),
                    );
                }
            },
            onError: () => {
                showErrorMessage(translate.formatMessage(commonMessage.error));
                setTableData([]);
            },
        });
    };

    useEffect(() => {
        fetchList();
    }, [service]);

    const handleDelete = (record) => {
        const objectName = translate.formatMessage(commonMessage.version);
        Modal.confirm({
            title: translate.formatMessage(commonMessage.deleteTitle, { objectName: record.fileName }),
            okText: translate.formatMessage(commonMessage.ok),
            cancelText: translate.formatMessage(commonMessage.cancel),
            centered: true,
            onOk: () => {
                executeDelete({
                    data: { service, fileName: record.fileName },
                    onCompleted: (res) => {
                        if (res?.result) {
                            showSucsessMessage(translate.formatMessage(commonMessage.deleteSuccess, { objectName }), translate);
                            fetchList();
                        } else {
                            showErrorMessage(translate.formatMessage(commonMessage.deleteFailed, { objectName }), translate);
                        }
                    },
                    onError: () => {
                        showErrorMessage(translate.formatMessage(commonMessage.deleteFailed, { objectName }), translate);
                    },
                });
            },
        });
    };

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            width: 60,
            align: 'center',
            render: (_, __, index) => index + 1,
        },
        {
            title: translate.formatMessage(commonMessage.fileName),
            dataIndex: 'fileName',
            render: (text, record) => {
                const fileName = text || '-';
                return (
                    <Button
                        type="link"
                        style={{ padding: 0 }}
                        href={`${record?.url}`}
                        target="_blank"
                        icon={<DownloadOutlined />}
                    >
                        {fileName}
                    </Button>
                );
            },
        },
        {
            title: translate.formatMessage(commonMessage.activeVersion),
            dataIndex: 'isActiveVersion',
            width: 180,
            align: 'center',
            render: (text) => text && <StarFilled style={{ color: '#faad14', fontSize: 16 }} title="Active Version" />,
        },
        {
            title: translate.formatMessage(commonMessage.dateRelease),
            dataIndex: 'dateRelease',
            render: (text) => (text ? convertUtcToLocalTime(text, DEFAULT_FORMAT, DEFAULT_FORMAT) : '-'),
            width: 200,
        },
        {
            title: translate.formatMessage(commonMessage.action),
            dataIndex: 'action',
            width: 120,
            align: 'center',
            render: (_, record) => (
                <Button
                    type="link"
                    danger
                    icon={<DeleteOutlined />}
                    title={translate.formatMessage(commonMessage.delete)}
                    onClick={() => handleDelete(record)}
                />
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, textAlign: 'right' }}>
                <Button icon={<PlusOutlined />} onClick={onAdd} style={{ marginRight: 8 }} type='primary'>
                    {translate.formatMessage(commonMessage.createNewVersion)}
                </Button>
                {/* <Button icon={<ReloadOutlined />} onClick={fetchList} loading={loadingList} /> */}
            </div>
            <BaseTable
                columns={columns}
                dataSource={tableData}
                loading={loadingList || loadingDelete}
                rowKey={(record) => record.key}
                pagination={false}
            />
        </div>
    );
};

export default AppVersionTable;
